import { createAction } from 'redux-actions';
import TransferStudent from '../utils/TransferStudent/TransferStudent'

export const editTransferStudent = createAction('EDIT_TRANSFER_STUDENT', TransferStudent.edit);
export const setTransferStudent = createAction('SET_TRANSFER_STUDENT')
export const updateTransferStudent = createAction('UPDATE_TRANSFER_STUDENT',TransferStudent.update)
// export const logoutAction = createAction('UPDATE_APPLICATION_FOR_ADMISSION', AuthDevise.logout);


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/TransferStudentAction.jsx